import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class BalliIntro extends Vue {
  submit() {
    this.$store.commit("markBalliComplete", "Intro");
    this.$router.push({ name: "ability" });
  }

  render(h: CreateElement) {
    return (
      <Card>
        <div slot="mainContent" style={{ textAlign: "center" }}>
          <span class="subtitle-1">
            Learning is fun, but it can also be challenging at times.
            Understanding what motivates you to learn is an important step for
            positive learning experiences. Let’s explore your own learning
            orientations.
          </span>
          <v-img
            src={require("@/assets/balli_explanation.png")}
            // width="55%"
            // height="55%"
            max-width="350px"
            style={{ margin: "0 auto" }}
          ></v-img>
        </div>
        <div slot="actions">
          <v-btn color="primary" onClick={this.submit}>
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(
              (this.$store.getters.progressBalli /
                this.$store.getters.numBalliQuestions) *
                100
            )}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = BalliIntro;
